import { useRecoilCallback } from 'recoil';
import { useStore } from '../../../../../../../../context/store';
import { useUISettings } from '../../../../../../../../context/network/http/QueryProvider/queries/UISettings';
import { ErrorMessageGetterWithRoundingValue } from '../../../../../../_grid/hooks/types';
import { isOverAllocatedBigJs } from '../../../../../../../../helpers/math';
import { createCellValueGetter } from '../../../../../../_grid/useGrid';
import { useTranslation } from '../../../../../../../../Locales/i18n/localizationService';

export const useCheckOverAllocation = () => {
	const { t } = useTranslation();
	const makeErrorNotification = useStore(store => store.addErrorNotification);
	const { data: uiSettings } = useUISettings();
	return useRecoilCallback(
		({ snapshot }): ErrorMessageGetterWithRoundingValue =>
			async ({ cell, columnIndex, newCellValue, rowFamilyTree }) => {
				// let changedValue = newCellValue;
				let errorMessage = undefined;
				if (!uiSettings.settings?.restrictOverAllocating) {
					return { errorMessage, changedValue: newCellValue };
				}
				const getCellValue = createCellValueGetter(snapshot);
				const currentCellValue = await getCellValue(cell)
				// Allow the user to gradually write down the value 
				if (newCellValue.lt(currentCellValue)) {
					return { errorMessage, changedValue: newCellValue };
				}
				
				const rootRow = rowFamilyTree[rowFamilyTree.length - 1];
				const totalCell = rootRow.columnRows[columnIndex].cells[0];
				const freeCap = await getCellValue(totalCell);
				const maxValue = currentCellValue.plus(freeCap);

				if (isOverAllocatedBigJs(newCellValue, maxValue, currentCellValue)) {
					errorMessage = t("CapacityViews.OverAllocation");
					makeErrorNotification(errorMessage);
				}
				return { errorMessage, changedValue: newCellValue };
			},
		[uiSettings.settings?.restrictOverAllocating, makeErrorNotification, t]
	);
};
